/**
 * Cart Tracking - Registra información del producto añadido al carrito
 * Escucha el evento 'variant:add' y envía datos al webhook de Priceshape
 */
(function () {

    // Escuchar cuando se añade al carrito
    document.addEventListener('variant:add', async function (event) {
        try {

            // Obtener el marketplace actual desde Shopify.country
            const marketplace = (Shopify.country || 'es').toLowerCase();

            const items = event.detail.items;

            // Iterar sobre cada item añadido al carrito
            for (let i = 0; i < items.length; i++) {
                const item = items[i];

                try {
                    // Verificar si existe SKU
                    if (!item.sku) {
                        console.warn('Cart Tracking: No se encontró SKU en el item');
                        continue;
                    }

                    const sku = item.sku;
                    const quantity = item.quantity || 1;

                    // Preparar payload para el webhook
                    const payload = {
                        sku: sku,
                        quantity: quantity,
                        site: 'yellowshop',
                        marketplace: marketplace
                    };

                    const endpoint = 'https://api.zacaris.com/priceshape/webhooks/addItemToCart';

                    // Enviar datos al webhook
                    const response = await fetch(endpoint, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(payload),
                        keepalive: true
                    }).catch(networkError => {
                        console.error(`Cart Tracking: Error de red para SKU ${sku}:`, networkError);
                        return null;
                    });

                    if (!response) {
                        console.error(`Cart Tracking: No se pudo enviar datos para SKU ${sku}`);
                        continue;
                    }

                    if (!response.ok) {
                        console.error(`Cart Tracking: Error en respuesta del webhook: ${response.status} ${response.statusText}`);
                    }

                } catch (error) {
                    console.error(`Cart Tracking: Error procesando item ${i + 1}:`, error);
                }
            }

        } catch (globalError) {
            console.error('Cart Tracking: Error global no capturado:', globalError);
        }
    });

})();
